import { Component, Input, OnChanges } from '@angular/core';

import { ICartDeliveryInfoProductType } from '../../../cart/models/delivery/i-cart-delivery-info';

@Component({
  standalone: false,
  selector: 'deliveries-notes',
  templateUrl: './deliveries-notes.component.html',
  styleUrls: ['./deliveries-notes.component.scss']
})
export class DeliveriesNotesComponent implements OnChanges {
  @Input() deliveryNoteForCustomer = '';
  @Input() availableProductTypes: ICartDeliveryInfoProductType[] = [];

  public productsWithUnavailableDays: { name: string; daysUnavailable: string[] }[] = [];
  public hasNotes = false;

  ngOnChanges() {
    this.productsWithUnavailableDays = (this.availableProductTypes || [])
      .reduce((acc: { name: string; daysUnavailable: string[] }[], { name, daysUnavailable }) => {
        if (daysUnavailable && daysUnavailable.length) {
          acc.push({
            name,
            daysUnavailable: daysUnavailable.map(d => d.charAt(0).toUpperCase() + d.slice(1).toLowerCase())
          });
        }
        return acc;
      }, []);

    this.hasNotes = Boolean(this.deliveryNoteForCustomer) || this.productsWithUnavailableDays.length > 0;
  }

  public getDayNameKey(day: string) {
    return `orderProcess.delivery.unavailableDays.days.${day.toLowerCase()}`;
  }
}
